import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  height: 100%;
  padding-top: 24px;
`;

export const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
`;

export const TitleWrapper = styled.div`
  font-weight: 600;
`;

export const RowWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;
